module.exports = __webpack_public_path__ + "img/plus.1a492aa8.svg";